import React, { useEffect, useState } from "react";
// import {
//   Pencil, PencilBox,
//   ArrowL, ArrowD, ArrowR,
//   ChevronR, ChevronD,
//   ThreeDotsV
// } from "../../components/Icons";
import { Button, CardContainer } from "../../components";
import alarm01 from "../../assets/sound/alarm01.mp3";

export default function AlarmSound(props) {

  const [myAlarm, setMyAlarm] = useState(null);

  const onload = () => {
    const audio = new Audio(alarm01);
    setMyAlarm(audio);
    console.log('Alarm Sound has been loaded!')
  }
  useEffect(() => onload(), [])

  const playAlarm = () => {
    try {
      myAlarm.play()
    } catch (e) {
      console.log(e.message)
    }
  }

  return (
    <CardContainer>
      <Button variant="outline-primary" title="Click to Sound Alarm" onClick={playAlarm} />
      {/* <br />
      <AudioPlayer soundTrack={alarm01} /> */}
    </CardContainer>
  )

}

// function AudioPlayer(props) {
//   const { soundTrack } = props;
//   return <audio src={soundTrack} controls />
// }
